import BindPositioningDevicesFittingsModal from './bind-positioning-devices-fittings-modal.vue'
export default BindPositioningDevicesFittingsModal
